import q from '../query.js';
import * as api from '../api/updates.js';
import keys from '@debbie/common/dist/cache/keys.js';
export const updateTypesEntity = `update-types`;
const updateTypesKey = `all-update-types`;
export const useUpdateTypes = () => q.query(updateTypesKey, api.types, keys.read.collection(updateTypesEntity));
//# sourceMappingURL=index.js.map